import { PropsWithChildren, useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { AppContext } from 'providers/AppProvider';
import { baseAction, userAction } from 'store/actions';
import { buildUserState } from 'store/state';
import { isLogged } from 'helpers';

export function User(props: Readonly<PropsWithChildren>) {
	const { dispatch, flowType, state } = useContext(AppContext);
	const { context, user } = state;
	const path = window.location.pathname;

	useEffect(() => {
		if (!isLogged(user)) {
			if (user.token) {
				dispatch([userAction, { user: buildUserState() }]);
			}
			if (Object.keys(context).length) {
				dispatch([baseAction, {}]);
			}
		}
	}, [user]); // eslint-disable-line

	if (
		path.endsWith('/curity') ||
		path.endsWith('/authenticate') ||
		path.startsWith('/waiver-confirmation') ||
		isLogged(user)
	) {
		return <>{props.children}</>;
	}

	return <Navigate replace to={`/${flowType}/authenticate`} />;
}
